<template>
    <div id="category-info">
        <div class="container">
            <div class="info-section" :style="'--category-color:' + categoryInfo.color">
                <div class="row">
                    <div class="col-12 col-sm-8 col-md-9 d-flex flex-column">
                        <div class="title col-8 col-sm-12 mt-4 mt-sm-3 mb-4">
                            <h1 class="title">
                                {{ this.$i18n.t(`categories-info.${categoryInfo.name}.title`) }}
                            </h1>
                        </div>
                        <div class="introduction mb-3 mt-2 mt-sm-0">
                            <p class="m-0">
                                {{ this.$i18n.t(`categories-info.${categoryInfo.name}.excerpt`) }}
                            </p>
                        </div>
                        <div class="subject" v-bind:class="{ expand: showSubject }" >
                            <p class="red" v-bind:class="{ open: showSubject }">
                                {{ this.$i18n.t(`categories-info.${categoryInfo.name}.content`) }}
                            </p>
                        </div>
                        <div class="button-wrapper mt-3">
                            <button class="back-button btn btn-primary read-more-button" @click="showMoreInfo()">
                                <font-awesome-icon class="plus" :icon="['fas', !showSubject ? 'plus' : 'minus']"/>
                                {{ !showSubject ? $t('read-more') : $t('read-less')}}
                            </button>
                        </div>
                    </div>
                    <div class="col-3 col-sm-4 col-md-3 image text-center">
                        <img class="info-img" :src="require(`@/assets/images/${categoryInfo.icon}`)" alt="">
                    </div>
                </div>
            </div>
            <div class="triangle" :style="'--category-color:' + categoryInfo.color"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ 'categoryInfo' ],
        data () {
            return {
                showSubject: false
            };
        },
        methods: {
            /**
             * Show or hide the subject section
             */
            showMoreInfo() {
                this.showSubject = !this.showSubject;
                if (!this.showSubject) {
                    window.scrollTo(0,0);
                }
            }
        }
    }
</script>
